import AdministrationContainer from "./AdministrationContainer";

export default AdministrationContainer;
